import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=9019bd28&scoped=true&"
import script from "./QuestionList.js?vue&type=script&lang=js&"
export * from "./QuestionList.js?vue&type=script&lang=js&"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=9019bd28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9019bd28",
  null
  
)

export default component.exports